<template>
  <div class="min-h-screen bg-background">
    <PageHeader />

    <main>
      <!-- Top Banner -->
      <div class="bg-[#7c2622] py-16">
        <div class="mx-auto max-w-[1400px] px-8 lg:px-12">
          <h1 class="font-serif text-3xl lg:text-4xl text-white">
            Key Dates
          </h1>
          <p class="text-white/70 mt-2">
            Important milestones for the award cycle.
          </p>
        </div>
      </div>

      <!-- Timeline Section -->
      <section class="py-20 lg:py-28 bg-gray-50">
        <div class="mx-auto max-w-[1400px] px-8 lg:px-12">

          <div class="max-w-2xl mb-16 animate-fade-in">
            <p class="text-sm font-medium tracking-widest uppercase text-gray-500 mb-4">
              Key Dates
            </p>

            <h2 class="font-serif text-3xl lg:text-4xl text-foreground mb-4">
              Award Cycle
            </h2>

            <p class="text-gray-600">
              Important milestones for the current award cycle.
            </p>
          </div>

          <div class="max-w-3xl">
            <div
              v-for="(event, index) in timelineEvents"
              :key="event.title"
              class="flex gap-8 pb-12 last:pb-0 animate-fade-in"
              :style="{ animationDelay: index * 0.1 + 's' }"
            >
              <!-- Date -->
              <div class="flex-shrink-0 w-40 text-right">
                <p class="text-sm font-medium text-foreground">
                  {{ event.date }}
                </p>
              </div>

              <!-- Dot + Line -->
              <div class="relative flex-shrink-0">
                <div class="h-3 w-3 bg-[#7c2622] rounded-full mt-1"></div>

                <div
                  v-if="index < timelineEvents.length - 1"
                  class="absolute left-1/2 top-4 bottom-0 w-px bg-gray-300 -translate-x-1/2"
                ></div>
              </div>

              <!-- Content -->
              <div class="flex-grow pb-8">
                <h3 class="font-medium text-foreground mb-1">
                  {{ event.title }}
                </h3>

                <p class="text-sm text-gray-600">
                  {{ event.description }}
                </p>
              </div>

            </div>
          </div>

        </div>
      </section>
    </main>

    <PageFooter />
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import PageFooter from "@/components/PageFooter.vue"

export default {
  name: "Timeline",
  components: {
    PageHeader,
    PageFooter,
  },
  data() {
    return {
      timelineEvents: [
        {
          date: "Throughout the Year",
          title: "Silent Identification",
          description:
            "Potential recipients are discreetly identified through ongoing observation, industry insight, and confidential recommendations.",
        },
        {
          date: "Ongoing",
          title: "Covert Evaluation",
          description:
            "Anonymous field assessments and internal reviews are conducted without the knowledge of candidates.",
        },
        {
          date: "Closed Deliberation",
          title: "Confidential Review",
          description:
            "All findings are assessed internally under sealed criteria to preserve the integrity of the selection process.",
        },
        {
          date: "Private Notification",
          title: "Discreet Confirmation",
          description:
            "Selected recipients are contacted privately prior to any public mention.",
        },
        {
          date: "By Invitation Only",
          title: "Low-Key Presentation",
          description:
            "Recognition is conferred through a modest, invitation-only presentation aligned with the values of authenticity and discretion.",
        },
      ],
    }
  },
}
</script>